import { Door, DoorActions, DoorButton, DoorText } from "@optymyse/suite-ui";
import { centralUrl } from "../../lib/hosts";
import { strings } from "../../lib/strings";
import { PRODUCT_KEY } from "../../../shared/product";

/**
 * What a workspace shows when Optymyse's access decision refuses it (403) or cannot be had (503): the suite's door,
 * in place of the workspace rather than sending the person away. The list of workspaces, on the central host, is a
 * step they choose.
 */
export function WorkspaceAccessNotice({ status }: { status: 403 | 503 }) {
  const copy = status === 403 ? strings.workspaces.access.denied : strings.workspaces.access.unavailable;
  return (
    <Door product={PRODUCT_KEY} title={copy.title} pip={status === 403 ? "locked" : "failed"}>
      <DoorText>{copy.body}</DoorText>
      <DoorActions>
        <DoorButton asChild variant={status === 403 ? "main" : "quiet"}>
          <a href={centralUrl("/admin")}>{strings.workspaces.access.toWorkspaces}</a>
        </DoorButton>
      </DoorActions>
    </Door>
  );
}
